import { Dayjs } from 'dayjs';
import Optional from '@/types/Optional';
import { Product } from './ProductRefactor';
import Rack from './Rack';
import ProductPackageLog from './ProductPackageLog';

export enum FOLIO_STATUS {
  BLANK = 'blank',
  ACTIVE = 'active',
  PACKAGED = 'packaged',
  SOLD = 'sold',
  WASTED = 'wasted',
}

interface Folio {
    id: string;
    status: FOLIO_STATUS;
    expirationDate: Dayjs;

    productId: Product['id'];
    rackId: Rack['id'];
    packageProductsLogId: Optional<ProductPackageLog['id']>;
    sku: Product['sku'];

    createdAt: Dayjs;
    updatedAt: Dayjs;
}


export interface FolioTag {
    id: Folio['id'];
    prodId: Product['id'];
    expDate: Dayjs;
}

export default Folio;
